module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ss-0b0f58edf447e463e793910b1f3f7de9.svg";